import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false }) => {
    const { currentUser, loading } = useAuth();

    // If we have a token in storage but no user yet, we should wait for Firebase
    const hasToken = !!localStorage.getItem('token');
    if (loading || (hasToken && !currentUser)) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                background: '#f8fafc'
            }}>
                <div className="spinner" style={{
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #0a9396',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <style>{`
                    @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                `}</style>
                <p style={{ marginTop: '20px', color: '#64748b', fontWeight: 500 }}>Verifying Session...</p>
            </div>
        );
    }

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    // Add admin check if needed
    // if (adminOnly && currentUser.role !== 'admin') {
    //   return <Navigate to="/" replace />;
    // }

    return children;
};

export default ProtectedRoute;
